import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
export function ProcessSection() {
  const {
    t
  } = useLanguage();
  const steps = [{
    en: 'Schedule Visit',
    es: 'Agenda Cita',
    descEn: 'Book consultation',
    descEs: 'Reserva consulta'
  }, {
    en: 'History Review',
    es: 'Historial',
    descEn: 'Medical background',
    descEs: 'Antecedentes'
  }, {
    en: 'Options',
    es: 'Opciones',
    descEn: 'Treatment plan',
    descEs: 'Plan de tratamiento'
  }, {
    en: 'Testing',
    es: 'Pruebas',
    descEn: 'Clearances',
    descEs: 'Autorizaciones'
  }, {
    en: 'Planning',
    es: 'Planificación',
    descEn: 'Prep for surgery',
    descEs: 'Prep cirugía'
  }, {
    en: 'Support',
    es: 'Apoyo',
    descEn: 'Long-term care',
    descEs: 'Cuidado continuo'
  }];
  return <section className="py-20 bg-slate-50 border-y border-slate-200" id="process" data-id="element-172">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
        <div className="text-center mb-16" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-4" data-id="element-175">
            {t('The Consultation Process', 'El proceso de consulta')}
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-176">
            {t('A clear, structured path to better health.', 'Un camino claro y estructurado hacia una mejor salud.')}
          </p>
        </div>

        {/* Desktop Horizontal Stepper */}
        <div className="hidden lg:grid grid-cols-6 gap-4 relative" data-id="element-177">
          {/* Connecting Line */}
          <div className="absolute top-8 left-0 right-0 h-0.5 bg-slate-200 -z-10 transform translate-y-1/2" data-id="element-178"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center text-center group" data-id="element-179">
              <div className="w-16 h-16 rounded-full bg-white border-4 border-[#0d9488] flex items-center justify-center shadow-sm mb-6 group-hover:scale-110 transition-transform duration-300 z-10 relative" data-id="element-180">
                <span className="text-2xl font-bold text-[#0f172a]" data-id="element-181">
                  {index + 1}
                </span>
              </div>
              <h3 className="text-lg font-bold text-[#0f172a] mb-1" data-id="element-182">
                {t(step.en, step.es)}
              </h3>
              <p className="text-sm text-slate-500" data-id="element-183">
                {t(step.descEn, step.descEs)}
              </p>
            </motion.div>)}
        </div>

        {/* Mobile Vertical Stepper */}
        <div className="lg:hidden space-y-8 relative pl-8 border-l-2 border-slate-200 ml-4" data-id="element-184">
          {steps.map((step, index) => <div key={index} className="relative pl-8" data-id="element-185">
              <div className="absolute -left-[41px] top-0 w-10 h-10 rounded-full bg-white border-4 border-[#0d9488] flex items-center justify-center shadow-sm" data-id="element-186">
                <span className="text-sm font-bold text-[#0f172a]" data-id="element-187">
                  {index + 1}
                </span>
              </div>
              <h3 className="text-lg font-bold text-[#0f172a] mb-1" data-id="element-188">
                {t(step.en, step.es)}
              </h3>
              <p className="text-sm text-slate-500" data-id="element-189">
                {t(step.descEn, step.descEs)}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}